import React from 'react';
import { addBottleneck } from 'owa-performance';
import { setScriptsLoadedAtPlt } from 'owa-shared-post-boot/lib/scriptsLoadedAtPlt';
import { render } from 'mini-react-dom/lib/render';
import { getWaitForReact } from 'owa-shared-bootstrap/lib/whyDidYouRender';
import { removeLoader } from 'mini-start/lib/utils/removeLoader';

const DOM_CONTENT_LOADED = 'DOMContentLoaded';

export async function asyncRender(node, container): Promise<void> {
    const waitForReact = getWaitForReact();
    if (waitForReact) {
        await waitForReact;
    }
    return new Promise(function (resolve, reject) {
        function onMount() {
            setScriptsLoadedAtPlt();
            removeLoader();
            setTimeout(resolve, 0);
        }

        function Component() {
            React.useEffect(onMount, []);
            return node;
        }

        function asyncRenderInternal(bottleneck) {
            addBottleneck('DR', bottleneck);
            try {
                render(React.createElement(Component, null), container, undefined);
            } catch (error) {
                reject(error);
            }
        }

        if (window.document.readyState !== 'loading') {
            asyncRenderInternal('R');
        } else {
            addDomLoadedEvent(asyncRenderInternal);
        }
    });
}

function addDomLoadedEvent(asyncRenderInternal) {
    function domLoaded() {
        window.document.removeEventListener(DOM_CONTENT_LOADED, domLoaded);
        asyncRenderInternal('EL');
    }
    window.document.addEventListener(DOM_CONTENT_LOADED, domLoaded, false);
}
